module.exports = __webpack_public_path__ + "img/myposition_cb_세르히오 라모스.1271c9e6.png";